import * as React from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    required
} from 'react-admin';

const AzureStorageCreate = props => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="account_name" validate={required()} />
            <TextInput source="account_key" validate={required()} />
            <TextInput source="container" />
        </SimpleForm>
    </Create>
);

export default AzureStorageCreate;